(() => {
  if (window.oldpassionServicesCodexBound) return;
  window.oldpassionServicesCodexBound = true;
  const updateHint = (select) => {
    const section = select.closest('.op-services');
    const hint = section && section.querySelector('[data-services-hint]');
    if (!hint) return;
    const hints = {
      'Firmengeschenke und Serien': 'Für wen ist das Geschenk oder die Serie gedacht? Welchen Artikel oder welche Idee hast du im Kopf?',
      'Hardware und Material': 'Welches Teil oder Material suchst du? Wofür brauchst du es? Masse und ungefähre Menge helfen uns bei der Abklärung.'
    };
    hint.textContent = hints[select.value] || 'Was möchtest du machen lassen oder beschaffen? Wofür wird es gebraucht?';
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-services-topic]');
    if (!link) return;
    const section = link.closest('.op-services');
    const select = section && section.querySelector('[data-services-select]');
    if (select) {
      select.value = link.dataset.servicesTopic;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-services-select]')) updateHint(event.target);
  });
  document.querySelectorAll('[data-services-select]').forEach(updateHint);
})();
